export const convertBlobToBase64 = (blobUrl) => fetch(blobUrl)
  .then((response) => response.blob())
  .then((blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      resolve(reader.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  }))
  .catch(() => blobUrl);

export const parseNode = (node) => {
  const nodeObj = node;

  // adjustments for all nodes
  nodeObj.labelHighlightBold = false;

  // adjustments for shape type (set and reset)
  nodeObj.size = 25;
  nodeObj.color = nodeObj.color || null;
  nodeObj.font = null;
  nodeObj.widthConstraint = null;
  nodeObj.heightConstraint = null;

  switch (nodeObj.shape) {
    case 'image':
      nodeObj.color = nodeObj.color || 'white';
      nodeObj.font = { vadjust: 10 };
      break;
    case 'square':
      nodeObj.color = nodeObj.color || null;
      nodeObj.size = 24;
      nodeObj.font = { vadjust: -45 };
      break;
    case 'diamond':
      nodeObj.color = nodeObj.color || null;
      nodeObj.size = 31;
      nodeObj.font = { vadjust: -50 };
      break;
    case 'box':
      nodeObj.color = nodeObj.color || null;
      nodeObj.font = { vadjust: 0 };
      nodeObj.widthConstraint = {
        minimum: 150,
        maximum: 150,
      };
      nodeObj.heightConstraint = {
        minimum: 60,
      };
      break;
    default:
  }

  return nodeObj;
};

export const parseEdge = (edge) => {
  const edgeObj = edge;
  edgeObj.hidden = edge.to === edge.from; // hide self effects
  return edgeObj;
};
